import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'
import {
  TABLE_HEAD_BG,
  TABLE_HEAD_BORDER,
  TABLE_ROW_DIVIDER,
  tableFixedEdgeInsetShadow,
} from './tableListTokens'

/**
 * Chiều rộng cột thao tác (icon): slot × số nút.
 * Slot đủ cho IconButton 28px + khoảng cách; 2 nút ≈ 68px.
 */
export const TABLE_ACTION_ICON_SLOT_PX = 34

export function tableActionsColWidthPx(iconCount: number): number {
  return Math.max(1, Math.floor(iconCount)) * TABLE_ACTION_ICON_SLOT_PX
}

export function tableActionsColDims(iconCount: number): { width: string; minWidth: string; maxWidth: string } {
  const px = tableActionsColWidthPx(iconCount)
  const s = `${px}px`
  return { width: s, minWidth: s, maxWidth: s }
}

const actionIconNested = {
  '& .MuiIconButton-root': {
    width: 28,
    height: 28,
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
    display: 'block',
  },
  '& > span': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
  },
} as const

/** Kẻ dọc trái cột sticky — inset shadow vì border-collapse làm mất border thật. */
function stickyActionsEdgeShadow(bottomColor: string): string {
  return `${tableFixedEdgeInsetShadow('left')}, inset 0 -1px 0 0 ${bottomColor}, -10px 0 16px -8px rgba(0,0,0,0.07)`
}

/** Ô cột thao tác: width cố định + icon gọn để vừa ô. */
export function tableActionsCellSx(iconCount: number): SystemStyleObject<Theme> {
  return {
    ...tableActionsColDims(iconCount),
    textAlign: 'center',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    px: '4px',
    whiteSpace: 'nowrap',
    ...actionIconNested,
  }
}

/** Sticky cột thao tác (header). */
export function tableActionsStickyHeadSx(theme: Theme): SystemStyleObject<Theme> {
  return {
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      right: 0,
      zIndex: 11,
      backgroundColor: `${TABLE_HEAD_BG} !important`,
      boxShadow: stickyActionsEdgeShadow(TABLE_HEAD_BORDER),
    },
  }
}

/** Sticky action cell from md breakpoint upward. */
export function tableActionsStickyCellSx(theme: Theme, iconCount: number, cellBg: string): SystemStyleObject<Theme> {
  return {
    ...tableActionsColDims(iconCount),
    textAlign: 'center',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    px: '4px',
    whiteSpace: 'nowrap',
    ...actionIconNested,
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      right: 0,
      zIndex: 2,
      backgroundColor: `${cellBg} !important`,
      boxShadow: stickyActionsEdgeShadow(TABLE_ROW_DIVIDER),
    },
  }
}
